import { useEffect } from 'react';
import { applyDocumentTitle } from '../utils/documentTitle';

export default function useDocumentTitle(pageTitle = '') {
  applyDocumentTitle(pageTitle);

  useEffect(() => {
    applyDocumentTitle(pageTitle);
  }, [pageTitle]);
}
